import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import _map from 'lodash/map';
import SVG from 'react-inlinesvg';
import helpIcon from '@lifesize/ux-assets/vectors/svgIcons/help-outline.svg';
import DropdownComp from 'components/Dropdown/Dropdown';
import Tooltip from 'components/Tooltip/Tooltip';
import classes from './SourceDisplay.module.scss';

class QualityDropdown extends React.Component {
  qualityDropdownButton = (open) => {
    const openClasses = [
      classes.openSelect,
      classes.openFlat
    ].join(' ');
    return (
      <div className={`${classes.videoSelect} ${open ? openClasses : ''}`} data-testid="quality-dropdown">
        {this.props.selectedQuality.label}
      </div>);
  };

  qualityGenerator = () => (
    <ul className={`${classes.sourceMenu} ${classes.shortMenu}`}>
      {_map(this.props.qualityList, (quality, index) => (
        <span key={index} title={quality.label}>
          <button
            onClick={() => this.props.selectVideoSource(quality)} data-testid="quality-dropdown-option"
          >
            {quality.label}
          </button>
        </span>
      ))}
    </ul>);

  render() {
    const dropdownClasses = [
      classes.sourceDropdown,
      classes.relativeDropdown
    ].join(' ');

    const titleClasses = [
      classes.subHeading,
      classes.subHeadingWithHelp
    ].join(' ');

    return (
      <div className={classes.dropdownContainer} style={{ marginTop: '-22px' }}>
        <div className={titleClasses}>
          <FormattedMessage
            id="components.avSettingsModal.sourceQuality"
            defaultMessage="Video Quality"
          />
          <button type="button" className={classes.subHeadingHelp}>
            <SVG src={helpIcon} data-testid="helpIcon" />
            <Tooltip
              fixPosition
              style={{ marginLeft: '10px', width: '210px', padding: '8px', whiteSpace: 'normal', textAlign: 'left' }}
              location="right"
              label={<FormattedMessage
                id="components.avSettingsModal.sourceQualityHelp"
                defaultMessage={
                  'Your video will be sent to other meeting participants at this quality. ' +
                  'Lowering your transmit quality can improve CPU performance, but will not provide the optimal meeting experience.'}
              />
              }
            />
          </button>
        </div>
        <DropdownComp
          buttonComponent={this.qualityDropdownButton()}
          openButtonComponent={this.qualityDropdownButton(true)}
          menuComponent={this.qualityGenerator()}
          dropdownClassName={dropdownClasses}
          containerClassName={classes.paddedDropdown}
          onOpen={this.props.onOpen}
        />
      </div>
    );
  }
}

QualityDropdown.propTypes = {
  selectedQuality: PT.object,
  qualityList: PT.array,
  relativeDropdown: PT.bool,
  selectVideoSource: PT.func,
  onOpen: PT.func,
  intl: PT.object
};

export default injectIntl(QualityDropdown);
